var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-box",on:{"click":function($event){return _vm.gotoPath()}}},[_c('i',{class:[_vm.menu_item.icon, 'inline-block', 'text-3xl', 'text-red-400']}),_c('p',{staticClass:"pt-2"},[_vm._v(_vm._s(_vm.menu_item.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }